module.exports = __webpack_public_path__ + "static/media/cross-primary.289a9245.svg";